import TweenLite from 'TweenLite'
import { select } from "@assets/scripts/utils";

export default function (selector, options = {}) {
    select(selector).forEach(item => {
        let tl = new TimelineMax
        const svg = item.querySelector('svg')
        if (!svg) return
        const paths = svg.querySelectorAll('path')


        item.addEventListener('mouseenter', e => {

            tl
                .add(() => {
                    item.classList.add('animated')
                },  0.05)
                .add(() => {
                    TweenLite.fromTo(paths[0], 1, { drawSVG: 0 }, { drawSVG: '100%' })
                    TweenLite.fromTo(paths[1], 0.5, { drawSVG: '100% 100%' }, { drawSVG: '100% 0', delay: 0.5 })
                    TweenLite.fromTo(paths[2], 0.5, { drawSVG: '100% 100%' }, { drawSVG: '100% 0', delay: 0.5 })
                    TweenLite.fromTo(paths[3], 0.5, { drawSVG: '100% 100%' }, { drawSVG: '100% 0', delay: 0.2 })
                    TweenLite.fromTo(paths[4], 0.5, { drawSVG: '100% 100%' }, { drawSVG: '100% 0', delay: 0.4 })
                    TweenLite.fromTo(paths[5], 0.5, { drawSVG: '100% 100%' }, { drawSVG: '100% 0', delay: 0 })
                })

        })

        item.addEventListener('mouseleave', e => {
            tl.clear()
            item.classList.remove('animated')
        })
    })
}
